module.exports = __webpack_public_path__ + "u12.no2.5e7e2cfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u12.no2.jpg
// module id = RX+T
// module chunks = 0